import { useQuery } from '@mint-lib/query-client';
import { useService } from '@mint-lib/routing-context';
import { CampaignManagerIntegrations } from '@mint-sdk/api-integrations';

export const useGetCampaignManagerIntegrations = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  const { data, isLoading } = useQuery(
    {
      ...CampaignManagerIntegrations.getQueryOptions({}),
      enabled,
    },
    queryClient,
  );

  return {
    data,
    isLoading,
  };
};
